import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form } from 'components';
import { FormWrapper } from 'components/Modal/styles';
import ModalForm from 'components/ModalForm/ModalForm';
import { useCreateCategory, useUpdateCategory } from 'api/products/hooks';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';
import validationSchemas from './schemas';

const CategoryForm = ({ type = 'create', initialValues, FormGroup }) => {
  const { t } = useTranslation(['pages', 'app']);
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);

  const { mutate: createCategory, isPending: isCreating } = useCreateCategory();
  const { mutate: updateCategory, isPending: isUpdating } = useUpdateCategory();

  return (
    <ModalForm
      initialValues={{
        uid: initialValues?.uid || undefined,
        name: initialValues?.name || '',
      }}
      onSubmit={({ uid, name }) =>
        type === 'update'
          ? updateCategory({ uid, name, region_uid: selectedRegion })
          : createCategory({ name, region_uid: selectedRegion })
      }
      validationSchema={validationSchemas.category}
      cancelLabel={t('app:cancel')}
      submitLabel={t(`app:${type}`)}
      pristine
      isLoading={isCreating || isUpdating}
      ignoreClickedState
      isClosePopupOn={false}
    >
      <FormWrapper>
        <FormGroup required label={t('app:name')}>
          <Form.Input type="text" name="name" />
        </FormGroup>
      </FormWrapper>
    </ModalForm>
  );
};

CategoryForm.propTypes = {
  type: PropTypes.oneOf(['create', 'update']),
  initialValues: PropTypes.object,
  FormGroup: PropTypes.func,
};

export default CategoryForm;
